import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import { API_URL } from '../../../SHARED/config/apiEndpoints';
import Parser from 'html-react-parser';
import { arrayClone } from '../../../SHARED/helpers/general.helper';

class CarouselTiles extends Component {

    getCarouselItems = () => {
        if(this.props.cards){
            let cards = arrayClone(this.props.cards);

            const newElems = cards.splice(0, 3);
            const newElemsLength = newElems.length;

            if(newElemsLength === 3) {
                let firstImg = newElems[0];
                let secondImg = newElems[1];
                let thirdImg = newElems[2];

                const firstItemStyle = {
                    backgroundImage: "url(" + API_URL + Parser(firstImg) + ")",
                    backgroundSize: "cover",
                    backgroundOrigin: "content-box",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center"
                };

                const secondItemStyle = {
                    backgroundImage: "url(" + API_URL + Parser(secondImg) + ")",
                    backgroundSize: "cover",
                    backgroundOrigin: "content-box",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center"
                };

                const thirdItemStyle = {
                    backgroundImage: "url(" + API_URL + Parser(thirdImg) + ")",
                    backgroundSize: "cover",
                    backgroundOrigin: "content-box",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center"
                };

                return (
                    <Fragment>
                        <div className="row three-elements">
                            <div className="col-6 first-img" style={firstItemStyle} />
                            <div className="col-6">
                                <div className="block-col second-img carousel-imgs" style={secondItemStyle}/>
                                <div className="block-col third-img carousel-imgs" style={thirdItemStyle}/>
                            </div>
                        </div>
                    </Fragment>
                );
            }

            if(newElemsLength === 2) {
                let firstImg = newElems[0];
                let secondImg = newElems[1];

                const firstItemStyle = {
                    backgroundImage: "url(" + API_URL + Parser(firstImg) + ")",
                    backgroundSize: "cover",
                    backgroundOrigin: "content-box",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundClip: "content-box"
                };

                const secondItemStyle = {
                    backgroundImage: "url(" + API_URL + Parser(secondImg) + ")",
                    backgroundSize: "cover",
                    backgroundOrigin: "content-box",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundClip: "content-box"
                };

                return (
                    <Fragment>
                        <div className="row two-elements">
                            <div className="col first-img" style={firstItemStyle} />
                            <div className="col " style={secondItemStyle}/>
                        </div>
                    </Fragment>
                );
            }

            if(newElemsLength === 1) {
                let firstImg = newElems[0];

                const firstItemStyle = {
                    backgroundImage: "url(" + API_URL + Parser(firstImg) + ")",
                    backgroundSize: "cover",
                    backgroundOrigin: "content-box",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center"
                };

                return (
                    <Fragment>
                        <div className="row two-elements">
                            <div className="col-lg-12 first-img" style={firstItemStyle} />
                        </div>
                    </Fragment>
                );
            }
        }
    };

    render() {
        return (
            <div className="carousel-tiles">
                { this.getCarouselItems() }
            </div>
        );
    }
}

const mapStateToProps = state => ({
});
export default connect(mapStateToProps, {})(CarouselTiles);





// WEBPACK FOOTER //
// ./src/FO/components/carouseltiles/carouseltiles.component.js